import { render, staticRenderFns } from "./modalDeleteAcao.vue?vue&type=template&id=30b5fbc5"
import script from "./modalDeleteAcao.vue?vue&type=script&lang=js"
export * from "./modalDeleteAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports